import { apiClient } from "@/lib/api/api-client"
import { AppConfig } from "../types/config"

export const configApi = {
  getConfigs: () => {
    return apiClient.get<AppConfig[]>(`configs`)
  },

  getConfig: (key: string) => {
    return apiClient.get<AppConfig>(`configs/${key}`)
  },

  createConfig: (payload: any) => {
    return apiClient.post<AppConfig>(`configs`, payload)
  },

  updateConfig: (payload: any) => {
    return apiClient.put<AppConfig>(`configs`, payload)
  },

  deleteConfig: (id: string) => {
    return apiClient.delete<void>(`configs/${id}`)
  },
}